import { createFileRoute } from "@tanstack/react-router"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { Header } from "~/components/reusable/Header"

export const Route = createFileRoute("/_auth/internal/others")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-col h-full">
      <Header>
        <BreadcrumbWrapper items={[{ label: "Others" }]} />
      </Header>

      <div className="flex flex-1 items-center justify-center">
        <p className="text-fg-subtle">Select a internal sub-page from the sidebar</p>
      </div>
    </div>
  )
}
